<div *ngIf="false" class="footer">
</div>
